import { request } from '@src/utility/request'
import { getIDTokenSub } from '@utils'

export const getProfile = async () => {
  const response = await request({
    method: 'get',
    url: `/person/${getIDTokenSub()}`
  })

  if (response && response.status === 200) {
    return response.data
  } else {
    throw new Error('Oops, backend server error')
  }
}


export const updateProfile = async (data) => await request({
  method: 'put',
  url: `/person/${data.awsId}`,
  data
})

export const getUser = async (id, orgId) => await request({
  method: 'get',
  url: `/person/details/${id}/${orgId}`
})

export const findUser = async (params) => await request({
  method: 'get',
  url: '/person/find',
  params
})

export const findUserWithChildren = async (params) => await request({
  method: 'get',
  url: '/person/findWithChildren',
  params
})

export const updateProfileImage = async (data) => await request({
  method: 'put',
  url: `/person/pic/${data.awsId}`,
  id: data.awsId,
  data: data.pic
})

export const updateChildImage = async (data) => await request({
  method: 'put',
  url: `/person/childPic/${data.id}`,
  id: data.id,
  data: data.pic
})

export const getEmail = async (data) => await request({
  method: 'get',
  url: `/person/email/${data.id}`
})

export const sendEmailVC = async (params) => await request({
  method: 'get',
  url: '/person/sendEmailVC',
  params
})

export const deleteProfile = async (data) => await request({
  method: 'delete',
  url: `/person/${data.awsId}`,
  data
})

export const saveNotifToken = async (data) => await request({
  method: 'post',
  url: '/person/notifToken',
  data
})

export const getNotifs = async (read) => await request({
  method: 'get',
  url: read ? '/person/notifs/true' : '/person/notifs/false'
})

export const readNotif = async (id) => await request({
  method: 'post',
  url: `/person/readNotif/${id}`
})

export const archiveNotifs = async (id) => await request({
  method: 'post',
  url: `/person/archiveNotifs/${id}`
})

export const getPayments = async () => await request({
  method: 'get',
  url: '/person/payments'
})

export const getAttends = async () => await request({
  method: 'get',
  url: '/person/attends'
})

export const getClasses = async () => await request({
  method: 'get',
  url: '/person/classes'
})

export const getMemStats = async () => await request({
  method: 'get',
  url: '/person/memStats'
})

export const getMemMetrics = async ({ from, to }) => await request({
  method: 'get',
  url: '/person/memMetrics',
  params: { from, to }
})

export const getMemProgress = async () => await request({
  method: 'get',
  url: '/person/memProgress'
})